module.exports = __webpack_public_path__ + "static/media/master_color.e0a38292.png";